import React from 'react';
export interface Column<T> {
  key: keyof T | string;
  label: string;
  render?: (item: T) => React.ReactNode;
}
interface TableProps<T> {
  columns: Column<T>[];
  data: T[];
  onRowClick?: (item: T) => void;
  keyExtractor: (item: T) => string | number;
}
export function Table<T>({
  columns,
  data,
  onRowClick,
  keyExtractor
}: TableProps<T>) {
  return <div className="w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm" data-id="element-1232">
      <div className="overflow-x-auto" data-id="element-1233">
        <table className="w-full text-left text-sm" data-id="element-1234">
          <thead className="bg-gray-50 text-gray-600 font-medium border-b border-gray-200" data-id="element-1235">
            <tr data-id="element-1236">
              {columns.map((col, index) => <th key={index} className="px-6 py-3 whitespace-nowrap" data-id="element-1237">
                  {col.label}
                </th>)}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100" data-id="element-1238">
            {data.length === 0 ? <tr data-id="element-1239">
                <td colSpan={columns.length} className="px-6 py-8 text-center text-gray-500" data-id="element-1240">
                  No data available
                </td>
              </tr> : data.map(item => <tr key={keyExtractor(item)} onClick={() => onRowClick && onRowClick(item)} className={`group transition-colors ${onRowClick ? 'cursor-pointer hover:bg-blue-50/50' : ''}`} data-id="element-1241">
                  {columns.map((col, index) => <td key={index} className="px-6 py-3 text-gray-700 whitespace-nowrap" data-id="element-1242">
                      {col.render ? col.render(item) : (item as any)[col.key]}
                    </td>)}
                </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}